import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "../ui/button";
import { company, navLinks } from "../../mock";
import LogoMark from "./LogoMark";

const Header = ({ onQuote }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/90 backdrop-blur border-b border-slate-200 shadow-sm" : "bg-white border-b border-transparent"}`}>
      {/* Top utility bar */}
      <div className="hidden md:block brand-band text-white text-[13px]">
        <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
          <div className="flex items-center gap-5">
            <span>{company.certification}</span>
            <span className="opacity-50">|</span>
            <span>GPCB Approved Unit</span>
            <span className="opacity-50">|</span>
            <span className="inline-flex items-center gap-1.5"><span className="h-1.5 w-1.5 rounded-full bg-emerald-300" /> GeM Registered</span>
          </div>
          <div className="flex items-center gap-4">
            <a href={`tel:${company.phone.replace(/\s/g, "")}`} className="hover:text-white/90 inline-flex items-center gap-2"><Phone className="h-3.5 w-3.5" /> {company.phone}</a>
            <span className="opacity-50">|</span>
            <a href={`mailto:${company.email}`} className="hover:text-white/90">{company.email}</a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-6 py-2.5 sm:py-3 flex items-center justify-between gap-3">
        <a href="#home" className="flex items-center gap-3 group shrink-0 min-w-0">
          <span className="block sm:hidden"><LogoMark size={40} className="group-hover:scale-[1.02] transition-transform" /></span>
          <span className="hidden sm:block lg:hidden"><LogoMark size={46} className="group-hover:scale-[1.02] transition-transform" /></span>
          <span className="hidden lg:block"><LogoMark size={52} className="group-hover:scale-[1.02] transition-transform" /></span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} className="px-3 py-2 text-[14px] font-medium text-slate-700 hover:text-teal-700 transition-colors rounded-md hover:bg-slate-50">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 shrink-0">
          <Button onClick={onQuote} className="hidden lg:inline-flex bg-teal-700 hover:bg-teal-800 text-white font-semibold px-4 h-9 rounded-lg shadow-sm shadow-teal-900/20 text-[13.5px]">
            Get a Quote
          </Button>
          <button aria-label="Open menu" className="lg:hidden p-2 rounded-md hover:bg-slate-100 text-slate-700" onClick={() => setOpen(!open)}>
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <div className="px-5 py-3 flex flex-col">
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-3 text-slate-700 hover:text-teal-700 font-medium border-b border-slate-100 last:border-b-0">
                {l.label}
              </a>
            ))}
            <Button onClick={() => { setOpen(false); onQuote(); }} className="mt-3 bg-teal-700 hover:bg-teal-800 text-white">Get a Quote</Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
